import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
import { convertISOTimeToString } from '../../../utils/date'
const cx = classnames.bind(styles)

const renderValue = value => convertISOTimeToString(value)

const TimeCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]

  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}_cell`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        data-elm-id={`${baseField}_${rowIndex}_value`}
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(_.get(row, field) || row[baseField])}
      </div>
    </Cell>
  )
}

/**
 * TimeCell is expecting time in ISO format and converts it to string format.
 * e.g. 10:00:00 to 10:00 AM
 */

TimeCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  data: PropTypes.array,
}

export default TimeCell
